import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Marquee from "react-fast-marquee";
import { Handshake } from "lucide-react";
import api from "../../lib/api";
import { EXAMPLE_PARTNERS } from "../../lib/exampleData";
import SectionHeading from "../SectionHeading";
import { Reveal } from "../Reveal";
import { ExampleBadge } from "../EmptyState";

export default function HomePartners() {
  const [partners, setPartners] = useState(null);

  useEffect(() => {
    api.get("/partners").then((r) => setPartners(r.data)).catch(() => setPartners([]));
  }, []);

  const isExample = partners !== null && partners.length === 0;

  return (
    <section className="bg-white py-24 sm:py-32 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 mb-12">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div className="flex items-start gap-4">
            <SectionHeading number="07" kicker="Ils nous soutiennent" title={<>Partenaires</>} />
            {isExample && <ExampleBadge className="mt-2" />}
          </div>
          <Reveal delay={0.2}>
            <Link
              to="/partenaires"
              data-testid="partners-see-all"
              className="group inline-flex items-center gap-3 border border-navy/25 text-navy font-heading uppercase tracking-wider text-sm px-6 py-3.5 hover:border-rouge hover:text-rouge transition-[border-color,color] duration-300"
            >
              <Handshake size={16} />
              Devenir partenaire
            </Link>
          </Reveal>
        </div>
      </div>

      <div data-testid="home-partners-marquee" className="border-y border-navy/10 py-10">
        <Marquee speed={30} gradient={false} pauseOnHover>
          {(isExample ? EXAMPLE_PARTNERS : partners || []).map((p, i) =>
            typeof p === "string" ? (
              <span
                key={i}
                className="mx-6 sm:mx-10 flex items-center justify-center border border-dashed border-navy/25 px-10 py-6 font-heading uppercase tracking-widest text-steel text-lg whitespace-nowrap"
              >
                {p}
              </span>
            ) : (
              <a
                key={p.id || i}
                href={p.website || "#"}
                target="_blank"
                rel="noopener noreferrer"
                className="mx-6 sm:mx-10 flex items-center gap-4 border border-navy/15 px-8 py-5 hover:border-rouge transition-colors duration-300"
              >
                {p.logo && <img src={p.logo} alt={p.name} className="h-10 w-auto object-contain" />}
                <span className="font-heading uppercase tracking-widest text-navy text-lg whitespace-nowrap">{p.name}</span>
              </a>
            )
          )}
        </Marquee>
      </div>
    </section>
  );
}
